export const selectionControlsColor = "--selectionControlsColor";
export const gridSpacing = "--gridSpacing";
export const hoverBoxTagHeight = "--hoverBoxTagHeight";
export const inverseZoom = "--inverseZoom";